<div>
    <div class="template1">
        <div class="verticaltree" (window:resize)="onResize($event)">
            <div class="body-title no-margin report-border">
                <div class="row">
                    <!-- <div class="col-sm-3 col-12 text-left report-username">
                    <b>{{memberName}} </b><span class="applyBlock">({{distributorId | numberformat}})</span></div> -->
                    <div class="col-sm-6 col-12 text-center full-width color-blue header-font ">
                        {{'treeview.Downline Map Report' |translate |translateKey}}
                        <span class="fa fa-question-circle-o font-size-12 report-title-tooltip"
                            popover="{{'treeview.It is a visual representation of the FBO entire downline. When user clicks on FBO namethe corresponding downline view will be displayed into multiple generations and can also view their volume and contact information,By default display the 1st generation downline members present under FBO in home country.' |translate |translateKey}}"
                            outsideClick="true" container="body" placement="bottom"></span> - <span
                            id="header-countryname" class="country-font-size">{{selectedCountry.name}}</span></div>
                    <!-- <div class="col-sm-3 col-12 text-right report-rundate">
                    <b>{{'common.Run Date:' |translate |translateKey}} </b> <span class="applyBlock">{{mydate}} </span></div> -->
                </div>
                <div class="row">
                    <!-- <div class="col-sm-6 col-12 text-center" [class.report-heading]="isMobile==false" [class.mob-report-heading]="isMobile==true">{{'treeview.Vertical Tree View' |translate |translateKey}}
                    <span class="mytooltip ico-help fa fa-question-circle-o font-size-18">
                        <span class="fa fa-question-circle-o font-size-18 report-title-tooltip"  popover="{{'treeview.It is a visual representation of the FBO entire downline. When user clicks on FBO namethe corresponding downline view will be displayed into multiple generations and can also view their volume and contact information,By default display the 1st generation downline members present under FBO in home country.' |translate |translateKey}}" outsideClick="true" container="body" placement="bottom"></span>
                    </span> - <span id="header-countryname">{{selectedCountry.name}}</span>
                </div>
                <div class="col-sm-3 col-6 text-left report-username">
                    <b>{{userName | titleCase}} </b>
                    <span class="applyBlock">({{distributorId | numberformat}})</span>
                </div> -->
                    <div class="text-right">
                        <b>{{'common.Run Date:' |translate |translateKey}} </b>
                        <span class="applyBlock">{{mydate}}</span>
                    </div>
                </div>
            </div>
            <div class="row shadow col-12 col-sm-12 col-md-12 col-lg-12 no-padding" id="countryFilter">
                <!-- <div class="row shadow col-12 col-sm-12 col-md-12 col-lg-12 no-padding"> -->
                <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3 mt-1">
                    <label for="country">{{'common.Country' |translate |translateKey}}
                        <span class="fa fa-question-circle-o report-title-tooltip"
                            popover="{{'common.Select Country' |translate |translateKey}}" outsideClick="true"
                            container="body" placement="right"></span>
                    </label>
                    <select [(ngModel)]="selectedCountry" class="form-control padding" title="Select Country"
                        (change)=(changeCountry(selectedCountry.value))>
                        <option *ngFor="let country of countries" [ngValue]="country"> {{country.name}} </option>
                    </select>
                </div>

                <div class="col-md-3 half-width">
                    <label for="reportType">{{'common.Member Level' |translate |translateKey}}
                    </label>
                    <select class=" ng-pristine form-control ng-invalid ng-touched" [(ngModel)]="selectedMemberLevel"
                        name="reportType" (change)='getdetailsByMemberLevel()'>
                        <option [selected]='true' [ngValue]="1">{{memberTypeConstants.AssistantManagerAndBelow}}
                        </option>
                        <option [ngValue]="2">{{memberTypeConstants.ManagersAndAbove}}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-sm-4 col-md-4 top-margin">
                    <label class="switch">
                        <input type="checkbox" [checked]="showNonZero"
                            (click)="showFilteredDownlineMembers(showNonZero)">
                        <span class="slider round"></span>

                    </label>
                    <label>{{'common.Show Non Zero Total CCs only' | translate | translateKey}}</label>
                </div>
                <div class="row clearboth">
                    <form [formGroup]="downlineMapForm">
                        <div class="col-md-3 left-padding-0">
                            <label for="dueDate"
                                class="control-label col-xs-8">{{'Common.Sponsor From Date'|translate | translateKey}}</label>
                            <div class="col-xs-12 floating-input floatLabelContainer right-padding-0">
                                <input #dueDate [owlDateTime]="dt3" class="form-control"
                                    placeholder="{{'customer-service.dd-mmm-yyyy'|translate | translateKey}}"
                                    appRestrictSpecialCharacters tabindex="0" maxlength="11" float-label DateFormat
                                    (blur)="transformFromDate(downlineMapForm.controls['fromDate'].value)"
                                    formControlName="fromDate">
                                <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt3>
                                </owl-date-time>
                                <span [owlDateTimeTrigger]="dt3"
                                    class="fa fa-calendar calendar-icon select-pointer"></span>
                            </div>
                        </div>
                        <div class="col-md-3 left-padding-0">
                            <label for="dueDate"
                                class="control-label col-xs-8">{{'Common.Sponsor To Date'|translate | translateKey}}</label>
                            <div class="col-xs-12 floating-input floatLabelContainer right-padding-0">
                                <input #dueDate [owlDateTime]="dt4" class="form-control"
                                    placeholder="{{'customer-service.dd-mmm-yyyy'|translate | translateKey}}"
                                    appRestrictSpecialCharacters tabindex="0" maxlength="11" float-label DateFormat
                                    (blur)="transformToDate(downlineMapForm.controls['toDate'].value)"
                                    formControlName="toDate">
                                <owl-date-time [pickerType]="'calendar'" panelClass="'calendar-panel'" #dt4>
                                </owl-date-time>
                                <span [owlDateTimeTrigger]="dt4"
                                    class="fa fa-calendar calendar-icon select-pointer"></span>
                            </div>
                        </div>
                    </form>
                    <div class="search form-group col-12 col-sm-6 col-md-6 col-lg-3 mt-1">
                        <input type="text" [(ngModel)]="searchText" (focus)="onFocus()" (focusout)="onFocusOut()"
                            placeholder="{{'treeview.Search by ID or Full Name(Ex: FIRSTNAME LASTNAME)' |translate |translateKey}}"
                            class="form-control" />
                        <span [hidden]="flag === false"
                            id="alert-text">{{'common.No records matched search criteria. Please update search criteria' |translate |translateKey }}
                        </span>
                        <div style="position: relative;">
                            <div [hidden]="isHierarchyAvailable == false" id="myDropdown"
                                class="dropdown-content col-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="summary col-12 col-sm-12 col-md-12 col-lg-12">
                                    {{'treeview.Search Summary' |translate |translateKey}}</div>
                                <div tabindex="0" *ngFor="let element of pathIdList">
                                    <a tabindex="0" (click)="openHierarchy(element)">{{element.name}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row col-12 col-sm-12 col-md-2 col-lg-3 mt-md-4 mar-top">
                        <div class="btn-apply-reset">
                            <button id="search" (keyup.enter)=search() (click)=search()>
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div class="btn-apply-reset" [class.d-none]="searchText == '' ">
                            <button id="search" (click)=reset()>
                                <i class="fa fa-undo"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div *ngIf="searchflag" class="col-xs-12 warning">{{'treeview.Warning: No downline found for the selected search criteria' |translate |translateKey}}</div>
                <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 no-padding legends">
                    <div class="row col-12 col-sm-12 col-md-12 col-lg-12 no-padding">
                        <div class="col-sm-6 col-md-6 col-12 col-lg-4 col-xl-4">
                            <i class="fa fa-circle-o" style="font-size:18px;color:rgb(155, 14, 56)"></i>
                            <h5 class="text">
                                {{'treeview.Manager and above' |translate |translateKey}}
                            </h5>
                        </div>
                        <div class="col-sm-6 col-md-6 col-12 col-lg-4 col-xl-4">
                            <i class="fa fa-circle-o" style="font-size:18px;color:rgb(226, 110, 15)"></i>
                            <h5 class="text">
                                {{'treeview.Assistant Manager' |translate |translateKey}}
                            </h5>
                        </div>
                        <div class="col-sm-6 col-md-6 col-12 col-lg-4 col-xl-4">
                            <i class="fa fa-circle-o" style="font-size:18px;color:rgb(115, 185, 9)"></i>
                            <h5 class="text">
                                {{'treeview.Supervisor' |translate |translateKey}}
                            </h5>
                        </div>
                        <div class="col-sm-6 col-md-6 col-12 col-lg-4 col-xl-4">
                            <i class="fa fa-circle-o" style="font-size:18px;color:teal"></i>
                            <h5 class="text">
                                {{'treeview.Assistant Supervisor' |translate |translateKey}}
                            </h5>
                        </div>
                        <div class="col-sm-6 col-md-6 col-12 col-lg-4 col-xl-4">
                            <i class="fa fa-circle-o" style="font-size:18px;color:rgba(6, 50, 117, 0.87);"></i>
                            <h5 class="text">
                                {{'treeview.Member' |translate |translateKey}}
                            </h5>
                        </div>
                        <div class="col-sm-6 col-md-6 col-12 col-lg-4 col-xl-4">
                            <i class="fa fa-circle" style="font-size:18px;color:rgba(6, 50, 117, 0.87);"></i>
                            <h5 class="text">
                                {{'treeview.Forever Business Owner with downline' |translate |translateKey}}
                            </h5>
                        </div>
                    </div>
                </div>
                <div id="zoomsettings" class="zoombuttons">
                    <button z class="zm" id="zm">
                        <i title="{{'common.Zoom out' |translate |translateKey}}" class="fa fa-search-minus"
                            aria-hidden="true"></i>
                    </button>
                    <button z class="zr" id="zr">
                        <i title="{{'common.Zoom reset' |translate |translateKey}}" class="fa fa-undo"
                            aria-hidden="true"></i>
                    </button>
                    <button z class="zp" id="zp">
                        <i title="{{'common.Zoom plus' |translate |translateKey}}" class="fa fa-search-plus"
                            aria-hidden="true"></i>
                    </button>
                    <button class="back">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span></span>
                    </button>
                </div>
            </div>
            <div class="content col-12 col-sm-12 col-md-12 col-lg-12 no-padding">
                <app-loader></app-loader>
                <div class="clearfix text-center shadow col-lg-12 no-padding tree" id="{{'tree' + fboid}}"></div>
                <div class="details open-details-tag" [class.open-details-tag]="isDetailsOpened">

                    <button id="slide" (click)="toggleDetailsPane()">
                        {{'treeview.Details' |translate |translateKey}}
                    </button>
                </div>
                <div class="col-lg-3 no-padding sidebar-details" [class.open-details]="isDetailsOpened">
                    <accordion>
                        <accordion-group heading="{{'treeview.Profile' |translate |translateKey}}" class="heading"
                            [isOpen]="true">
                            <div id="profile" class="normal">
                                <img alt="No image available" id="member-image" [src]="profilePicUrl"
                                    (error)="setDefaultPaymentPic()" />
                                <span id="profileName">
                                    <h3 class="center">{{profile.name}}</h3>
                                </span>
                                <h4 class="center">{{profile.level}}</h4>
                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.ID' |translate |translateKey}}
                                    </div>
                                    <div class="col-6 mx-0 no-padding">
                                        <span class="float-right">{{distributorId}}</span>
                                        <!-- <span class="float-right" *ngIf="!isDetailsOpened">{{profile.id}}</span> -->
                                    </div>
                                </div>
                                <div class="border-top col-md-12 no-padding subheading">
                                    {{'treeview.Contact' |translate |translateKey}}
                                </div>

                                <div class="border-top row mx-0 no-padding">
                                    <div class="col-md-11 no-padding txt-wrap">
                                        <span title='{{profile.contact.email}}'>
                                            {{profile.contact.email}}
                                        </span>

                                    </div>
                                    <div class="col-md-1 no-padding right-align">
                                        <span class="float-right">
                                            <i class="fa fa-envelope icon"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="border-top row mx-0 no-padding">
                                    <div class="col-md-11 no-padding">
                                        {{profile.contact.mobile}}
                                    </div>
                                    <div class="col-md-1 no-padding right-align">
                                        <span class="float-right">
                                            <i class="fa fa-phone icon"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                        <accordion-group heading="{{'treeview.Volume' |translate |translateKey}}" class="heading">
                            <div id="volume" class="normal">
                                <div class="row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Personal CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{volume.personalCCMtd}}(MTD)
                                            {{volume.personalCCYtd}}(YTD)</span>
                                    </div>
                                </div>

                                <div class="border-top row mx-0 no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Non-Manager CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{volume.nonManagerCC}}(MTD)
                                            {{volume.nmCCYtd}}(YTD)</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.FBO CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-6 no-padding right-align">
                                        <span class="float-right">{{volume.fboCCMtd}}(MTD)
                                            {{volume.fboCCYtd}}(YTD)</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Total Active CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{volume.totalActiveCCMtd}}(MTD)
                                            {{volume.totalActiveCCYtd}}(YTD)</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Total CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{volume.totalCCMtd}}(MTD)
                                            {{volume.totalCCYtd}}(YTD)</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Total CC 2MTD' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding right-align">
                                        <span class="float-right">{{volume.totalCC2Mtd}}(2MTD)</span>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                        <accordion-group heading="{{'treeview.Global Rally' |translate |translateKey}}" class="heading">
                            <div id="globalrally">
                                <div class="row col-sm-12 col-md-12 col-md-12 no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Global Rally CCs' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding right-align">
                                        <span class="float-right">{{globalRally.globalRallyCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row col-sm-12 col-md-12 col-md-12 no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Global Rally Level' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding right-align">
                                        <span class="float-right">{{globalRally.globalRallyLevel}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.CC to Next Level' |translate |translateKey}} [1.5K]
                                    </div>
                                    <div class="col-md-4 no-padding right-align">
                                        <span class="float-right">1500</span>
                                    </div>
                                </div>

                                <div class="border-top col-md-12 no-padding subheading" style="text-align:center">
                                    {{'treeview.Rewards' |translate |translateKey}}
                                </div>
                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Lodging and Meals' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">5D/4N</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Spending Cash ($USD)' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">500</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Activity Allowance' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">300</span>
                                    </div>
                                </div>

                                <div class="border-top col-md-12 no-padding subheading" style="text-align:center">
                                    {{'treeview.Next Level Rewards' |translate |translateKey}}
                                </div>
                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Lodging and Meals' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">6D/5N</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Spending Cash ($USD)' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">500</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Activity Allowance' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">300</span>
                                    </div>
                                </div>
                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.VIP' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">Yes</span>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                        <accordion-group heading="{{'treeview.Eagle Manager'|translate |translateKey}}" class="heading">
                            <div id="eaglemanager" class="normal">
                                <div class="row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Home Country Total CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding">
                                        <span class="float-right">{{eagleManager.homeCountryTotalCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Home New N/M CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{eagleManager.eagleHomeNewNMCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Non-Home New N/M CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding">
                                        <span class="float-right">{{eagleManager.eagleNonHomeNewNMCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Global New N/M CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding">
                                        <span class="float-right">{{eagleManager.newEagleManagerGlobalCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Potential Eagle Managers' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span
                                            class="float-right">{{eagleManager.potentialEagleManagersRequired}}(Required)
                                            {{eagleManager.potentialEagleManagersActual}}(Actual)</span>
                                    </div>
                                </div>
                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Number of New Supervisors' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">0(Required)
                                            {{eagleManager.numberofNewSupervisors}}(Actual)</span>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                        <accordion-group heading="{{'treeview.Chairman\'s Bonus' |translate |translateKey}}"
                            class="heading">
                            <div id="chairmanbonus" class="normal">
                                <div class="row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Home Personal N/M CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding right-align">
                                        <span class="float-right">{{chairmansBonus.homePersonalNMCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Home New N/M CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{chairmansBonus.chairmanHomeNewNMCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Non-Home New N/M CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{chairmansBonus.chairmanNonHomeNewNMCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Global New N/M CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding">
                                        <span class="float-right">{{chairmansBonus.newChairmansBonusGlobalCC}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Potential Managers' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding">
                                        <span class="float-right">{{chairmansBonus.potentialManagers}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Potential 600CC Managers' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{chairmansBonus.potential600CCManagers}}</span>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                        <accordion-group heading="{{'treeview.Forever2Drive' |translate |translateKey}}"
                            class="heading">
                            <div id="forever2drive" class="normal">
                                <div class="row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Forever2Drive Status' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding">
                                        <span class="float-right">{{forever2Drive.forever2DriveStatus}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Forever2Drive Level' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{forever2Drive.forever2Drivelevel}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Forever2Drive Qual Date' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{forever2Drive.forever2DriveQualDate}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Forever2Drive Expiration Date' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span class="float-right">{{forever2Drive.forever2DriveExpirationDate}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Forever2Drive Re-Qualification Start Date' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span
                                            class="float-right">{{forever2Drive.forever2DriveReQualificationStartDate}}</span>
                                    </div>
                                </div>

                                <div class="border-top col-md-12 no-padding subheading" style="text-align:center">
                                    {{'treeview.QUALIFICATION REQUIREMENT' |translate |translateKey}}
                                </div>
                                <div class="border-top row no-padding" *ngIf="month">
                                    <div class="col-md-4 no-padding">
                                        {{'common.' + month[0] |translate |translateKey}}
                                    </div>
                                    <div class="col-md-8 no-padding right-align">
                                        <span class="float-right">50(Required)
                                            {{volume.totalCCMtd.monthOne}}(Actual)</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding" *ngIf="month">
                                    <div class="col-md-4 no-padding">
                                        {{'common.' + month[1] |translate |translateKey}}
                                    </div>
                                    <div class="col-md-8 no-padding right-align">
                                        <span class="float-right">100(Required)
                                            {{volume.totalCCMtd.monthTwo}}(Actual)</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding" *ngIf="month">
                                    <div class="col-md-4 no-padding">
                                        {{'common.' + month[2] |translate |translateKey}}
                                    </div>
                                    <div class="col-md-8 no-padding">
                                        <span class="float-right right-align">110(Required)
                                            {{volume.totalCCMtd.monthThree}}(Actual)</span>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                        <accordion-group heading="{{'treeview.Leadership Bonus' |translate |translateKey}}"
                            class="heading">
                            <div id="leadershipbonus" class="normal">
                                <div class=" row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Recognized Manager' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding">
                                        <span class="float-right">{{leadershipBonus.isRecognizedManager}}</span>
                                    </div>
                                </div>

                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Number of Leadership Managers' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">{{leadershipBonus.numberofLeadershipManagers}}</span>
                                    </div>
                                </div>
                                <div class="border-top row no-padding">
                                    <div class="col-md-8 no-padding">
                                        {{'treeview.Leadership Qualified' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-4 no-padding">
                                        <span class="float-right">{{leadershipBonus.isLeadershipQualified}}</span>
                                    </div>
                                </div>
                                <div class="border-top row no-padding">
                                    <div class="col-md-6 no-padding">
                                        {{'treeview.Leadership Bonus CC' |translate |translateKey}}
                                    </div>
                                    <div class="col-md-6 no-padding right-align">
                                        <span
                                            class="float-right">{{leadershipBonus.leadershipBonusCCRequired}}(Required)
                                            {{leadershipBonus.leadershipBonusCCActual}}(Actual)</span>
                                    </div>
                                </div>
                            </div>
                        </accordion-group>
                        <accordion-group heading="{{'treeview.Gem Bonus' |translate |translateKey}}" class="heading">
                            <div class="row no-padding normal">
                                <div class="col-md-6 no-padding">
                                    {{'treeview.First Generation Active Managers' |translate |translateKey}}
                                </div>
                                <div class="col-md-6 no-padding">
                                    <span class="float-right">{{gemBonus.firstGenActiveManagerscount}}</span>
                                </div>
                            </div>
                        </accordion-group>
                    </accordion>
                </div>
            </div>
        </div>
        <div *ngIf="errormessage==true" id="errormessage">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {{'common.Sorry, Something Went Wrong: Please try again later.' |translate}}
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/downline-map.component.html